import React from "react";
import Register from "components/Register";
import Layout from "components/common/Layout";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";
import { UserFieldsOptions, USER_FIELDS_OPTIONS_QUERY } from "hooks/useUserFieldsOptions";

function RegisterPage() {
  return (
    <Layout>
      <Register />
    </Layout>
  );
}

export default RegisterPage;

export const getServerSideProps = withEnhancedServerSideProps(async ctx => {
  if (ctx.isInitialRequest) {
    await ctx.apolloClient.query<UserFieldsOptions>({ query: USER_FIELDS_OPTIONS_QUERY });
  }

  return {
    props: {
      allowed: ["guest"],
    },
  };
});
